import styled from 'styled-components';
import { media } from 'utils/style';
import QuoteMessageNonFeasible from './QuoteMessageNonFeasible';

export default styled(QuoteMessageNonFeasible)`
  background-color: #e0eaff;
  padding: 1rem 2.6rem;
  border: 1px solid var(--primary200);
  border-radius: 4px;
  font-size: 1.6rem;
  color: var(--grey800);
  font-weight: 400;
  width: 100%;
  white-space: pre-line;
  margin-bottom: 25px;
  .quote-message-non-feasible__secondary-link {
    color: var(--primary500);
    font-weight: 700;
    text-decoration: none;
  }
  ${media.lessThan('large')`
    border: none;
  `}
`;
